<template>
  <div>
    <GmapMap
      :center="{ lat: Number(bngLat), lng: Number(bngLng) }"
      :zoom="7"
      map-type-id="terrain"
      :style="{ width: '100%', height: `${height}` + 'px' }"
    >
      <GmapMarker
        v-for="s in trucks"
        :key="s.unit_id"
        :position="{ lat: Number(s.latitude), lng: Number(s.longitude) }"
        :clickable="true"
        :icon="{
          url: require(`../../../public/img/icon/trucks.png`),
          size: { width: 96, height: 48, f: 'px', b: 'px' },
          scaledSize: { width: 96, height: 48, f: 'px', b: 'px' },
        }"
        @click="toStatus(s.station._id)"
      >
        <GmapInfoWindow
          :position="{ lat: Number(s.latitude), lng: Number(s.longitude) }"
        >
          {{ s.licenseplate }}
        </GmapInfoWindow>
        <GmapCircle
          :center="{ lat: Number(s.latitude), lng: Number(s.longitude) }"
          :radius="7000"
          :visible="true"
          :options="{
            strokeColor: `${colorStation(s)}`,
            strokeOpacity: 0.05,
            strokeWeight: 10,
            fillColor: `${colorStation(s)}`,
            fillOpacity: 0.05,
          }"
        />
      </GmapMarker>
    </GmapMap>
  </div>
</template>

<script>
export default {
  props: ["trucks", "bngLat", "bngLng", "height"],

  methods: {
    colorStation(stage) {
      switch (stage) {
        case "01":
          return "#078847";
        case "02":
          return "#FF0000";
      }
    },
    toStatus(s) {
      this.$router.push({ path: "/station/status/" + s.id });
    },
  },
};
</script>

<style lang="scss" scoped></style>
